import * as angular from "angular";
import {IController} from "angular";
import * as _ from 'lodash';
import {PlanningCommonService} from "../../services/planning-coomon-service.service";
import {PlanningViewSettingsModel, PlanningViewSettingsRouteModel} from "../../models/planning-view-settings.model";

export class PlanningActivityOverviewComponent implements IController {

  activity: any;
  route: any;
  jobs: any;
  settings: PlanningViewSettingsModel
  onSettingsChange: Function;
  onViewJob: Function;
  onMoveToLeftovers: Function;
  onClose: Function;

  public routeColor: any;

  constructor(private planningCommonService: PlanningCommonService) {
  }

  $onInit() {
    if (this.route) {
      this._setRouteColor();
    }
  }

  $onChanges(changes) {
    if (changes.activity && !changes.activity.isFirstChange()) {

    }
    if (changes.route && !changes.route.isFirstChange()) {
      this._setRouteColor();
    }
  }

  onMoveJobsToLeftovers() {
    this.onMoveToLeftovers({ids: _.map(this.jobs, 'id')});
  }

  private _setRouteColor() {
    this.routeColor = this.planningCommonService.getRouteColor(this.route);
  }


}

angular
  .module('bringoz.admin.planning')
  .component('planningActivityOverview', {
    bindings: {
      activity: '<',
      route: '<',
      jobs: '<',
      settings: '<',
      onSettingsChange: '&',
      onViewJob: '&',
      onMoveToLeftovers: '&',
      onClose: '&'
    },
    template: require('./planning-activity-overview.html').default,
    controller: PlanningActivityOverviewComponent
  });

